import { COLORS } from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import { IMenuGroupItemsFilters } from 'src/view/screens/MenuManagementScreen/screens/MenuGroupEditScreen/types/menuGroupEdit';
import { IMenuGroupCategory, IMenuGroupProduct } from 'src/view/screens/MenuManagementScreen/screens/MenuGroupsScreen/types/menuGroups';
import { TLabelTheme } from '~/view/components/Controls/Label';

/**
 * Get item availability status option for label
 *
 * @param item
 */
export const getItemAvailabilityLabelOptions = (item: IMenuGroupProduct): { text: string; color: TLabelTheme } => {
  switch (true) {
    case item.status && !item.out_of_stock:
      return { text: localeStore.t('available'), color: COLORS.GREEN };
    case item.status && !!item.out_of_stock:
      return { text: localeStore.t('out_of_stock'), color: COLORS.GRAY };
    default:
      return { text: localeStore.t('not_available'), color: COLORS.RED };
  }
};

/**
 * Is empty categories items list
 *
 * @param categories
 */
export const isCategoriesWithoutItems = (categories: IMenuGroupCategory[]): boolean => {
  return categories.every((category) => !category?.items?.length);
};

/**
 * Get list of all items included in categories
 *
 * @param categories
 */
export const getCategoriesItems = (categories: IMenuGroupCategory[]): IMenuGroupProduct[] => {
  return categories.map((category) => category.items || []).flat();
};

/**
 * Get percentage width for main and secondary table columns
 *
 * @param withCategories
 * @param withTaker360Price
 */
export const getItemsTableColumnsWidth = (withCategories: boolean, withTaker360Price: boolean): [number, number] => {
  const numOfColumns: number = 4 + +withCategories + +withTaker360Price;

  switch (numOfColumns) {
    case 6:
      return [30, 14];
    case 5:
      return [36, 16];
    default:
      return [40, 20];
  }
};

/**
 * Get filtered category items list
 *
 * @param categories
 * @param selectedCategory
 * @param search
 */
export const getItemsList = (
  categories: IMenuGroupCategory[],
  selectedCategory: IMenuGroupCategory | undefined,
  search: IMenuGroupItemsFilters['search']
): IMenuGroupProduct[] => {
  if (!categories.length || !selectedCategory?.items) return [];

  // filter items by search
  if (search.isFocused) {
    return getCategoriesItems(categories).filter((item) => item.name[localeStore.language].toLowerCase().includes(search.value));
  }

  return selectedCategory.items;
};

/**
 * Is name should be in one line without line breaking
 *
 * @param name
 */
export const shouldTruncateCategoryName = (name: string) => {
  return name
    .split(' ')
    .slice(0, 3)
    .some((part) => part.length > 15);
};

/**
 * Get items with category and validated sizes
 *
 * @param category
 */
export const formatItems = (category: IMenuGroupCategory): IMenuGroupProduct[] => {
  return category.items.map((item) => ({
    ...item,
    sizes: item.is_size ? item.sizes : [],
    category: { id: category.id, name: category.name },
  }));
};
